import $ from "jquery";

(function ($) {

  $(window).ready(function () {

    //	ADD TO BOOKMARKS
    $(".addToBookmark").click(function()
    {

      var page_id = $("#page_id").val();
      var page_title = $("#page_title").val();
      var page_url = $("#page_url").val();

      var page_object = {
        id: page_id,
        title: page_title,
        url: page_url
      }

      var pages = [];
      pages.push(page_object);

      var bookmarked_pages = JSON.parse(localStorage.getItem("bookmarks"));

      if (bookmarked_pages)
      {
        bookmarked_pages.forEach(function(page)
        {
          if (page.id !== page_id)
          {

            var object = {
              id: page.id,
              title: page.title,
              url: page.url
            }

            pages.push(object);
          }
          else
          {
            alert("Page Already Saved");
          }
        });
        localStorage.setItem('bookmarks', JSON.stringify(pages));
      }
      else
      {
        localStorage.setItem('bookmarks', JSON.stringify(pages));
      }

      var store = JSON.parse(localStorage.getItem("bookmarks"));

      $(".bookmarks .counter").html(store.length);

    });

    //	LOAD INITIAL BOOK MARK COUNTER
    var store = JSON.parse(localStorage.getItem("bookmarks"));
    if (store)
    {
      $(".bookmarks .counter").html(store.length);
    }
    else
    {
      $(".bookmarks .counter").html("0");
    }

    //	LOAD BOOKMARKS PAGE
    if ($("body").hasClass("page-template-template-bookmarks"))
    {
      var bookmarks = JSON.parse(localStorage.getItem("bookmarks"));
      var list = "";
      if (bookmarks)
      {
        bookmarks.forEach(function(page)
        {
          list += "<div class='titles'><a href='" + page.url + "'>" + page.title + "</a></div>";
        });
      }
      $("#load-bookmarks").html(list);
    }

  });

})(jQuery);